import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vnApp_emaki} from "../components/vnApp_emaki";
import {menuNav_template} from "../components/templates/menuNav_template";
import {header} from "./header";
import { vnApp } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app";

declare var ko: any;
declare var page: any;

export class menu_mod extends vnModule_knockoutJS {

    protected menu: menuNav_template;
    protected XHRHdls: XMLHttpRequestHandler[] = [];

    protected getModuleName() {
        return "main-nav";
    }

    buildContent(): Array<Element> {

        // Create the menu template object
        this.menu = new menuNav_template("mainMenu", this.viewModel, this);
        this.menu.setDefaultSectionId(44);

        return [this.menu.build()];
    }

    public setBrandsMenuData(permissions): void {

        let vnApp: vnApp = this.getVnAppZone().app;

        this.setContextBrand();

        // set the user
        this.menu.setUser(vnApp.loggedUser);

        let brands = vnApp.loggedUser.user.brands;

        let menuBrands =  [];

        let roles = vnApp.loggedUser.user.valnet_user.roles;

        for (let b of brands) {
            if (!b.isDeleted) {
                let row = Object.assign([], b);
                //row.id = row.shortName;
                menuBrands.push(row);
            }
        }

        //set the selectable brands of the user
        this.menu.setBrands(menuBrands);

        //if user is a candidate hide all brands
        if(roles.length == 1 && roles.find(r => r.id == 20) != null){
            this.menu.setBrands([]);
            this.menu.disableUserLink();
            this.menu.disableEmakiLink();
        }


        // If a brand is selected, setup the menu's options

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;

        if (this.getGlobalBrandId()) {

            let idBrand = this.getGlobalBrandId();

            for (let i of menuBrands) {
                if( i.id==idBrand){
                    (<header>loadedModule).setBrandClass('prop ' + i.iconImage);
                    (<header>loadedModule).setBrandName(i.name);
                    (<header>loadedModule).setBrandShortName(i.shortName);
                    (<header>loadedModule).setBrandDomain(i.domain);

                }
            }

            this.menu.setSelectedBrand(idBrand);
            this.menu.setMenus(this.updateMenuListItemWithBrandSelection(idBrand));
        } else {

            this.menu.setMenus([]);
            (<header>loadedModule).setBrandClass("");
            (<header>loadedModule).setBrandName("");
            (<header>loadedModule).setBrandDomain('');
            window.sessionStorage.removeItem('currentBrandId');
        }

        this.handlePartsVisibility();
    }

    private handlePartsVisibility(): void {
        this.menu.handleComponentVisibility();
    }

    public getGlobalBrandId() {
        return this.getVnAppZone().getGlobal("idBrand");
    }

    public fillPage() : void{

        //
        // Following action are only executed if the user is logged in
        let vnApp = this.getVnAppZone().app;
        if (vnApp.loggedUser != null && vnApp.loggedUser.isLoggedIn) {

            this.getMenuData();
        }
    }

    public getMenuData(): void{

        if( "getMenuData" in this.XHRHdls ){
            this.XHRHdls["getMenuData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON({menu: 'brand', idBrand : this.vnAppZone.getApp().params.idBrand}));
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        let usrReq_url: string = '/api/emaki/menu';
        this.XHRHdls['getMenuData'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getMenuData'].onReadyStateFunction = this.onMenuDataRequestReturn;
        this.XHRHdls['getMenuData'].execute();

    }

    protected onMenuDataRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);

                obj.menu.setMenuItems(response.formMenu);
                obj.setBrandsMenuData(response.permissions);


                let idBrand = obj.getVnAppZone().app.params.idBrand;
                if(idBrand){
                    let zoneHeader = obj.getVnAppZone().app.getZoneByName("Header");
                    let loadedModule = zoneHeader.loadedModule;
                    (<header>loadedModule).getUserSessionTrackerData(idBrand);
                }
            });
        }
    }

    public getActiveMenus() {
        let actives =  this.getVnAppZone().getGlobal("brandActiveMenus");
        if (actives == undefined) {
            actives = [];
        }

        return actives;
    }

    public resetActiveMenus() {
        this.getVnAppZone().addGlobal({index: "brandActiveMenus", value: []});
    }


    public setActiveMenus(data) {
        let globalMenu = this.getActiveMenus()
        let index = globalMenu.indexOf(data.id);

        if (data.level == 1) {
            if (index == -1) {
                globalMenu = [data.id];
            } else {
                globalMenu.splice(index, 1);
            }
            this.toggleMenuGroup(data);
        } else {

            if (data.selected()) {
                if (index == -1) {
                    globalMenu = [data.id];
                }
            } else {
                if (index > -1) {
                    globalMenu.splice(index, 1);
                }
            }
        }

        this.getVnAppZone().addGlobal({index: "brandActiveMenus", value: globalMenu});
    }

    public toggleMenuGroup(data): void {

        if (data.level == 1) {
            let elementId = 'li-' + data.identifier;
            let dropDown = document.getElementById(elementId).querySelector('.dropdown-list');
            if (data.selected()) {
                dropDown.classList.remove('is-hidden');
            } else {
                dropDown.classList.add('is-hidden');
            }
        }
    }

    protected handleActiveMenus(data): void {

        this.setActiveMenus(data);

        let menus = this.menu.getMenus();
        menus.forEach((m) => {

            if (m.id != data.id) {

                m.selected(false);
            }
        });
    }

    protected changeSelection(selectionId) {

        this.menu.activateLoading();

        //
        // update the global value of the selected brand
        this.getVnAppZone().addGlobal({index: "idBrand", value: selectionId});

        this.resetGlobalSelectedBrandMenuPage();

        //
        //update the menu item list to use the idBrand in the url
        let menuItems = this.updateMenuListItemWithBrandSelection(selectionId);

        //
        let _this = this;
        setTimeout(function () {
            _this.menu.deactivateLoading();
        }, 500);

        let articleLink = menuItems.filter((m) => {
            return (m.text == "Articles");
        });

        // change the url to the brand specific one /brand/x/
        if (articleLink.length > 0) {
            page("/brand/" + selectionId + "/articles");
        }else{
            page("/brand/" + selectionId + "/home");
        }

    }

    protected updateMenuListItemWithBrandSelection(idBrand) {

        let menuItems = this.menu.getTemplateViewModel().menuItems();

        menuItems.forEach((m) => {

            if (m['idSection'] != null) {
                m['url'] = String(m['url']).replace('{id}', idBrand);
            }

            m.subMenus.forEach((sm) => {
                sm['url'] = String(sm['url']).replace('{id}', idBrand);
                delete sm['subMenus'];
            });
        });

        this.menu.getTemplateViewModel().menuItems(menuItems);

        return menuItems;
    }

    //
    // this function exist to prevent problem in the menu when reloading the page
    //
    protected setContextBrand() {

        if (this.getVnAppZone().getApp().params.idBrand) {

            let idBrand = this.getVnAppZone().getApp().params.idBrand;
            this.getVnAppZone().addGlobal({index: "idBrand", value: idBrand});
        }else {

            this.getVnAppZone().removeGlobal("idBrand");
        }
    }

    protected viewProfile(idUser) {
        page('/users/profile/' + idUser);
    }


    protected viewApplication(){
        page('/job/applications/')
    }

    setGlobalSelectedBrandMenuPage(menuPageId): void {

        window.sessionStorage.setItem('selectedBrandMenuPageId', menuPageId);
    }

    getGlobalSelectedBrandMenuPage() {

        return window.sessionStorage.getItem("selectedBrandMenuPageId");
    }

    resetGlobalSelectedBrandMenuPage(): void {

        window.sessionStorage.setItem("selectedBrandMenuPageId", null);
    }

    public getDefaultSectionId(sectionId) {
        return this.menu.getDefaultSectionId();
    }

}



// WEBPACK FOOTER //
// ./js/modules/menu.ts